/* unsafe-eval */

/**
 * jQuery
 */
import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

window.jdmn = {
    log: function (_args, _c = "black") {
        if ($("body").hasClass("role-administrator")) console.log(`%c${_args}`, `color: ${_c}`);
    },
};

ScrollTrigger.config({
    ignoreMobileResize: true,
});

$(document).ready(function () {
    jdmn.log("document ready", "green");
    $("html").addClass("document-ready");
});

$(window).on("load", function () {
    jdmn.log("window loaded", "green");
    $("html").addClass("window-loaded");
    // ScrollTrigger.refresh();
});

$(window).on("scrollDirectionChange", function (e) {
    $("html").attr("data-scroll-pos", `${e.detail.pos}`);
    $("html").attr("data-scroll-dir", `${e.detail.dir}`);
});

// import escKey from "imports/event_esc-key";
// import mutation from "imports/event_mutation";
import resize from "imports/event_resize";
import scrollDirectionChange from "imports/event_scroll-direction-change";
//
// import accordion from "imports/function_accordion";
// import audio from "imports/function_audio";
// import contain from "imports/function_contain";
// import cover from "imports/function_cover";
// import draggable from "imports/function_draggable";
import customAnimations from "imports/function_custom-animations";
import driftingType from "imports/function_drifting-type";
// import flipImage from "imports/function_flip-image";
// import lightbox from "imports/function_lightbox";
import lazyLoad from "imports/function_lazy-load";
import menuActions from "imports/function_menu-actions";
// import panningImage from "imports/function_panning-image";
import parallax from "imports/function_parallax";
// import panorama from "imports/function_panorama";
// import poll from "imports/function_poll";
// import scrollTween from "imports/function_scroll-tween";
// import tabFocus from "imports/function_tab-focus";
import toggleClass from "imports/function_toggle-class";
import uiColor from "imports/function_ui-color";
import slider from "imports/function_slider";
// import zoom from "imports/function_zoom";
// import zoomImage from "imports/function_zoom-image";
//
// import chapterTitle from "custom/custom_chapter-title";
// import hero from "custom/custom_hero";
// import hummer from "custom/custom_hummer";
